<template>
  <div class="w-full h-auto min-h-screen mt-3 justify-between bg-white space-y-9 rounded-t-[20px]">
    <HeaderComponent page-title="Profile" />
    <div class="mx-8 my-8">
      <div class="text-center">
        <h1 class="text-4xl font-bold text-primaryDark mb-4">User Profile</h1>
        <p class="text-grayDark mb-6">Profile management will be available soon</p>
        <router-link to="/dashboard" class="text-blue-500 hover:underline">
          Return to Dashboard →
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderComponent from './HeaderComponent.vue';

export default {
  name: 'ProfileComponent',
  components: {
    HeaderComponent,
  },
};
</script>